import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth';

// Global error handler to suppress Firestore internal state machine errors
// These occur during auth transitions and are temporary - they don't affect functionality
window.addEventListener('error', (event) => {
  const error = event.error;
  if (error?.message?.includes('FIRESTORE') && 
      error?.message?.includes('INTERNAL ASSERTION FAILED') && 
      (error?.message?.includes('Unexpected state') || error?.message?.includes('ID: b815') || error?.message?.includes('ID: ca9'))) {
    // Suppress these specific Firestore internal errors from appearing in console
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Also handle unhandledrejection for promises
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (error?.message?.includes('FIRESTORE') && 
      error?.message?.includes('INTERNAL ASSERTION FAILED') && 
      (error?.message?.includes('Unexpected state') || error?.message?.includes('ID: b815') || error?.message?.includes('ID: ca9'))) {
    // Suppress these specific Firestore internal errors
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
